import { each, filter, find, map } from 'lodash-es';

import * as api from './../../api/api.service';
import * as rfps from './../../api/rfps/rfp.service';

interface OfferDropdown {
  id: any;
  value: any;
  isEnabled: any;
  options: any;
}

class ResponseNavSubmitResponseController {
  showSubmittingIndicator = false;

  offerDropdowns: OfferDropdown[];

  constructor(
    private $scope,
    private modalPromise,
    private OfferHelper,
    private api: api.IApiService,
    private account,
    private rfp: rfps.RfpVersionTwo,
    private LoadingIndicator,
    private offers?
  ) {
    'ngInject';

    if (!offers) {
      this.loadOffers().then((offers) => {
        this.renderOffers(offers);
      });
    } else {
      this.renderOffers(offers);
    }
  }

  loadOffers() {
    let loader = this.api.rfps.loadOffers(
      this.rfp.id,
      this.account.organization.id
    );

    this.LoadingIndicator.waitFor(loader);

    loader.then((offers) => {
      this.offers = offers;
    });

    return loader;
  }

  renderOffers(offers) {
    // Check whether the offers have structure set
    this.OfferHelper.updateOffers(offers);
    each(offers, (offer: any) => {
      let offerOptions = {
        id: offer.id,
        value: 'Include',
        isEnabled: true,
        options: ['Include', 'Delete']
      };
      if (!this.OfferHelper.isOfferComplete(offer)) {
        offerOptions.value = 'Delete';
        offerOptions.isEnabled = false;
        offerOptions.options = ['Delete'];
      }
      if (Array.isArray(this.offerDropdowns)) {
        this.offerDropdowns.push(offerOptions);
      } else {
        this.offerDropdowns = [offerOptions];
      }
    });
  }

  getDropdown(offer) {
    return find(this.offerDropdowns, {
      id: offer.id
    });
  }

  /**
   * Just need to pass the backend a list of objects with offer id's
   */
  getIncludedOffers() {
    let includedOffers = filter(this.offerDropdowns, { value: 'Include' });

    let offersList = map(includedOffers, (offer: OfferDropdown) => {
      return {
        id: offer.id
      };
    });

    // console.log(offersList);

    return offersList;
  }

  /**
   * Does any offer have catalog changes?
   */
  hasCatalogChanges() {
    let hasChanges = find(this.offers, (offer: any) => {
      return offer.catalogChanges && offer.catalogChanges.autoAppliedChanges;
    });

    return !!hasChanges;
  }

  cancel() {
    this.modalPromise.reject();
    this.$scope.$hide();
  }

  continueSubmitOffer() {
    // let offers = _.map(this.offers, 'id');

    let offers = this.getIncludedOffers();

    let submitLoader = this.api.rfps.sellers.submitResponse(
      this.rfp.id,
      this.account.organization.id,
      offers
    );

    this.LoadingIndicator.waitFor(submitLoader);

    submitLoader.then(
      (response) => {
        this.modalPromise.resolve(response);
        this.$scope.$hide();
      },
      () => {
        this.$scope.$hide();
      }
    );
  }
}

export default class ResponseNavSubmitResponseModalService {
  constructor(private $q, private $bsModal) {
    'ngInject';
  }

  openModal(account, rfp, offers): ng.IPromise<any> {
    const modalPromise = this.$q.defer();

    this.$bsModal({
      locals: {
        modalPromise: modalPromise,
        account: account,
        rfp: rfp,
        offers: offers
      },
      controller: ResponseNavSubmitResponseController,
      controllerAs: '$ctrl',
      show: true,
      placement: 'center',
      template: `<div class="modal submit-response-modal" tabindex="-1" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" aria-label="Close" ng-click="$ctrl.cancel()"><i class="fa fa-times"></i></button>
                <h3 class="modal-title">Send Your Response</h3>
              </div>
              <div class="modal-body">
                <div class="modal-inner-content">
                  <div style="margin: 0 0 15px;" class="alert alert-danger" ng-if="$ctrl.hasCatalogChanges()">
                    <b>Alert!</b> aptitude product catalog updated, changes applied to offer
                  </div>

                  <div class="offers-list" style="border-bottom: 1px solid #ccc; margin-bottom: 10px; font-weight: bold;">
                    <div class="offers-col">Offers</div>
                    <div class="complete-col">Complete</div>
                    <div class="status-col">Status</div>
                  </div>

                  <div class="offers-list" ng-repeat="offer in $ctrl.offers" ng-init="offerDropdown = $ctrl.getDropdown(offer)">
                    <div class="offers-col">
                      {{ offer.name }}
                    </div>
                    <div class="complete-col">
                      <i class="fa fa-lg" style="display: inline-block;" ng-class="$ctrl.OfferHelper.getOfferCompleteClass(offer)"></i>
                      <span style="line-height: 25px; vertical-align: top;">{{ $ctrl.OfferHelper.isOfferComplete(offer) ? 'Yes' : 'No' }}</span>
                    </div>
                    <div class="status-col">
                      <select class="form-control" ng-class="{ 'disabled': !offerDropdown.isEnabled }"
                              ng-attr-aria-label="{{offer.name + ' status'}}"
                              ng-model="offerDropdown.value"
                              ng-options="option as option for option in offerDropdown.options track by option"
                              ng-disabled="!offerDropdown.isEnabled"></select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" style="width: 100px;" ng-click="$ctrl.continueSubmitOffer()">Send</button>
              </div>
            </div>
          </div>
        </div>`
    });

    return modalPromise.promise;
  }
}
